export default {
  id: 249,
  title: 'Target #249 - Letter R',
  url: 'https://cssbattle.dev/play/249',
  colors: ['#2F2F2F', '#D9D9D9'],
  solution:
    '<p a><p b><p c><style>body,p[a],p[b]{background:#2f2f2f}p[a],p[c]{bottom:20}p{position:fixed;margin:0}p[a]{right:2;width:258;height:150;border:60px solid #d9d9d9;border-radius:100px 0 0 100px;border-width:0 0 60px 60px}p[b]{top:20;left:20;width:160;height:40;border:60px solid #d9d9d9;border-radius:0 1in 1in 0;border-left-width:0}p[c]{left:20;width:60;height:100;background:#d9d9d9',
}
